import { FeatureFlag } from '../FeatureFlag';

export const allowFeedBackendTicker = new FeatureFlag({
    key: 'allow-feed-backend-ticker',
    defaultValue: false,
});
